import type { RouteStep, RouteTrack } from "@/app/queries";

export type StepState = RouteStep["state"];
export type Seg = "done" | "active" | "rest";

/** Сегменты трека (S1/S3/S8): пройденные, текущий, остальные. */
export function segs(total: number, done: number, active: boolean): Seg[] {
  return Array.from({ length: total }, (_, i) => (i < done ? "done" : i === done && active ? "active" : "rest"));
}

/** Доля для кольца — только от данных, без «капли» из макета. */
export function ringPct(done: number, total: number): number {
  return total > 0 ? Math.min(1, done / total) : 0;
}

export const STATE_MARK: Record<StepState, { mark: string; label: string }> = {
  done: { mark: "✓", label: "пройден" },
  active: { mark: "▸", label: "в работе" },
  open: { mark: "○", label: "доступен" },
  locked: { mark: "·", label: "закрыт" },
};

export function stateMark(state: StepState) {
  return STATE_MARK[state];
}

/** Подпись состояния трека в рейле S1. */
export function trackStateLabel(t: RouteTrack): string {
  if (t.total > 0 && t.done === t.total) return "гейты сданы";
  const active = t.steps.find((s) => s.state === "active");
  if (active) return `шаг ${active.position} в работе`;
  return "закрыт";
}

/** Цвет кольца трека: акцент у активного, ok у завершённого, граница у закрытого. */
export function trackRingColor(t: RouteTrack): string {
  if (t.total > 0 && t.done === t.total) return "var(--ok)";
  if (t.steps.some((s) => s.state === "active")) return "var(--acc)";
  return "var(--bd2)";
}
